<section class="form-field-container">
  <article class="form-field-container__actions gt-xs:pr-3">
    @if (showLockIcon) {
      <div class="readonly-icon">
        <ts-icon [matTooltip]="lockIconTooltip" [icon]="'ts_lock-alt'" [color]="'gray'"></ts-icon>
      </div>
    }
    @if (!!showTip) {
      <div class="tooltip-icon">
        <ts-icon [matTooltip]="tooltipContent" [icon]="'info'" [color]="'gray'"></ts-icon>
      </div>
    }
    @if (!alwaysHideHistory) {
      <div class="history-panel-icon cursor-pointer" #historyPanelOrigin>
        <ts-icon [icon]="'history'" [color]="'gray'" (click)="openHistoryPanel()"></ts-icon>
      </div>

      <ng-template #historyPanel>
        <div class="history-overlay">
          <div class="history">
            <app-field-history [model]="model" [fieldDef]="fieldDef" [data]="data"></app-field-history>
          </div>
        </div>
      </ng-template>
    }
  </article>

  @if (showRedactedValue) {
    <div class="flex-auto gt-xs:pr-3 w-full mb-2">
      <ts-input
        [label]="fieldDef.label"
        [testId]="'form-field-' + fieldDef.name"
        [formControl]="redactedControl"
        [blurred]="true"
      />
    </div>
  }

  <!-- Outside the @if: the static form-field-host query can't resolve inside a conditional block. -->
  <ng-template form-field-host></ng-template>
</section>
